// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import Homepage from "./pages/Homepage";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ResetPass from "./pages/ResetPass";
import ConfirmEmail from "./pages/ConfirmEmail";
import SpinnerWithLoading from "./components/Spinner";
import NewPass from "./pages/NewPass";
import RegisterVerify from "./pages/RegisterVerify";
import EventsAdmin from "./pages/EventsAdmin";
import Profile from "./pages/Profile.js";
import NotFound from "./pages/404.js";
import Confidentialitate from "./pages/Confidentialitate.js";
import Conditii from "./pages/conditii.js";
import Psihoterapie from "./pages/Psihoterapie.js";
import PsihoterapieIndividuala from "./pages/PsihoterapieIndividuala.js";
import EvaluarePsihologica from "./pages/EvaluarePsihologica.js";
import SupervizarePsihologieClinica from "./pages/SupervizarePsihologieClinica.js";
import PracticaPsihologica from "./pages/PracticaPsihologica.js";
import EvaluareCopii from "./pages/EvaluareCopii.js";
import TerapieGrup from "./pages/TerapieGrup.js";
import Blog from "./pages/blog.js";
import Alexandra from "./pages/Alexandra.js";
import Produs from "./pages/produs.js";
import Magazin from "./pages/shop.js";
import Contact from "./pages/Contact.js";
import DespreNoi from "./pages/DespreNoi.js";
import ConsilierePsihologica from "./pages/ConsilierePsihologica.js";
import Contributii from "./pages/Contributii.js";
import UnderConstruction from "./pages/UnderConstruction.js";
import { LoadingProvider } from "./context/LoadingContext";

const App = () => {
  return (
    <LoadingProvider>
      <div>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPass />} />
          <Route path="/confirm-email" element={<ConfirmEmail />} />
          <Route path="/new-password" element={<NewPass />} />
          <Route path="/register-verify" element={<RegisterVerify />} />
          <Route path="/evenimente" element={<EventsAdmin />} />
          <Route path="/profil" element={<Profile />} />
          <Route path="/404" element={<NotFound />} />
          <Route
            path="/evaluare-copii-adolescenti"
            element={<EvaluareCopii />}
          />
          <Route path="/terapie-de-grup" element={<TerapieGrup />} />
          <Route
            path="/evaluare-psihologica"
            element={<EvaluarePsihologica />}
          />
          <Route
            path="/supervizare-psihologie-clinica"
            element={<SupervizarePsihologieClinica />}
          />
          <Route
            path="/practica-psihologica"
            element={<PracticaPsihologica />}
          />
          <Route path="/psihoterapie" element={<Psihoterapie />} />
          <Route
            path="/psihoterapie-individuala"
            element={<PsihoterapieIndividuala />}
          />
          <Route path="/conditii" element={<Conditii />} />
          <Route path="/Alexandra" element={<Alexandra />} />
          <Route path="/contributii" element={<Contributii />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route
            path="/consiliere-psihologica"
            element={<ConsilierePsihologica />}
          />
          <Route path="/produs" element={<Produs />} />
          <Route path="/produs" element={<Produs />} />
          <Route path="/produs" element={<Produs />} />
          <Route path="/produs" element={<Produs />} />
          <Route path="/produs" element={<Produs />} />
          <Route path="/magazin" element={<Magazin />} />
          <Route path="/despre-noi" element={<DespreNoi />} />
          <Route path="/confidentialitate" element={<Confidentialitate />} />
          <Route path="/under-construction" element={<UnderConstruction />} />
        </Routes>
        <SpinnerWithLoading />
        {/* Afișează spinner-ul când e nevoie */}
      </div>
    </LoadingProvider>
  );
};

export default App;
